"use strict";

var _interopRequireDefault = require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es.array.concat.js");
require("core-js/modules/es.number.constructor.js");
require("core-js/modules/es.number.to-fixed.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.regexp.test.js");
require("core-js/modules/web.dom-collections.for-each.js");
var _classCallCheck2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/classCallCheck.js"));
var _createClass2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/createClass.js"));
var _callSuper2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/callSuper.js"));
var _inherits2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/inherits.js"));
var _defineProperty2 = _interopRequireDefault(require("/Volumes/Untitled/project/185/185admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
var _tslib = require("tslib");
var _vuePropertyDecorator = require("vue-property-decorator");
var _EditorImage = _interopRequireDefault(require("./components/EditorImage.vue"));
var _plugins = _interopRequireDefault(require("./plugins"));
var _toolbar = _interopRequireDefault(require("./toolbar"));
var _dynamicLoadScript = _interopRequireDefault(require("./dynamicLoadScript"));
var tinymceCDN = "https://cdn.jsdelivr.net/npm/tinymce-all-in-one@4.9.3/tinymce.min.js";
var Tinymce = /*#__PURE__*/function (_Vue) {
  function Tinymce() {
    var _this2;
    (0, _classCallCheck2.default)(this, Tinymce);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = (0, _callSuper2.default)(this, Tinymce, [].concat(args));
    (0, _defineProperty2.default)(_this2, "id", void 0);
    (0, _defineProperty2.default)(_this2, "value", void 0);
    (0, _defineProperty2.default)(_this2, "toolbar", void 0);
    (0, _defineProperty2.default)(_this2, "menubar", void 0);
    (0, _defineProperty2.default)(_this2, "height", void 0);
    (0, _defineProperty2.default)(_this2, "width", void 0);
    (0, _defineProperty2.default)(_this2, "hasChange", false);
    (0, _defineProperty2.default)(_this2, "hasInit", false);
    //@ts-ignore
    (0, _defineProperty2.default)(_this2, "tinymceId", _this2.id);
    (0, _defineProperty2.default)(_this2, "fullscreen", false);
    (0, _defineProperty2.default)(_this2, "languageTypeList", {
      en: "en",
      zh: "zh_CN",
      es: "es_MX",
      ja: "ja"
    });
    return _this2;
  }
  (0, _inherits2.default)(Tinymce, _Vue);
  return (0, _createClass2.default)(Tinymce, [{
    key: "containerWidth",
    get: function get() {
      var width = this.width;
      if (/^[\d]+(\.[\d]+)?$/.test(width)) {
        // matches `100`, `'100'`
        return "".concat(width, "px");
      }
      return width;
    }
  }, {
    key: "watchValue",
    value: function watchValue(val) {
      var _this3 = this;
      if (!this.hasChange && this.hasInit) {
        this.$nextTick(function () {
          return window.tinymce.get(_this3.tinymceId).setContent(val || "");
        });
      }
    }
  }, {
    key: "mounted",
    value: function mounted() {
      this.init();
    }
  }, {
    key: "activated",
    value: function activated() {
      if (window.tinymce) {
        this.initTinymce();
      }
    }
  }, {
    key: "deactivated",
    value: function deactivated() {
      this.destroyTinymce();
    }
  }, {
    key: "destroyed",
    value: function destroyed() {
      this.destroyTinymce();
    }
  }, {
    key: "init",
    value: function init() {
      var _this4 = this;
      // dynamic load tinymce from cdn
      (0, _dynamicLoadScript.default)(tinymceCDN, function (err) {
        if (err) {
          _this4.$message.error(err.message);
          return;
        }
        _this4.initTinymce();
      });
    }
  }, {
    key: "initTinymce",
    value: function initTinymce() {
      var _this5 = this;
      var _this = this;
      window.tinymce.init({
        selector: "#".concat(this.tinymceId),
        language: this.languageTypeList["en"],
        height: this.height,
        body_class: "panel-body ",
        object_resizing: false,
        toolbar: this.toolbar.length > 0 ? this.toolbar : _toolbar.default,
        menubar: this.menubar,
        plugins: _plugins.default,
        end_container_on_empty_block: true,
        powerpaste_word_import: "clean",
        code_dialog_height: 450,
        code_dialog_width: 1000,
        advlist_bullet_styles: "square",
        advlist_number_styles: "default",
        imagetools_cors_hosts: ["www.tinymce.com", "codepen.io"],
        default_link_target: "_blank",
        link_title: false,
        nonbreaking_force_tab: true,
        init_instance_callback: function init_instance_callback(editor) {
          _this5.$emit("onInit");
          if (_this.value) {
            editor.setContent(_this.value);
          }
          _this.hasInit = true;
          editor.on("NodeChange Change KeyUp SetContent", function () {
            _this5.hasChange = true;
            _this5.$emit("input", editor.getContent());
          });
        },
        setup: function setup(editor) {
          editor.on("FullscreenStateChanged", function (e) {
            _this.fullscreen = e.state;
          });
        }
      });
    }
  }, {
    key: "destroyTinymce",
    value: function destroyTinymce() {
      var tinymce = window.tinymce.get(this.tinymceId);
      if (this.fullscreen) {
        tinymce.execCommand("mceFullScreen");
      }
      if (tinymce) {
        tinymce.destroy();
      }
    }
  }, {
    key: "setContent",
    value: function setContent(value) {
      window.tinymce.get(this.tinymceId).setContent(value);
    }
  }, {
    key: "getContent",
    value: function getContent() {
      window.tinymce.get(this.tinymceId).getContent();
    }
  }, {
    key: "imageSuccessCBK",
    value: function imageSuccessCBK(arr) {
      var _this = this;
      arr.forEach(function (v) {
        window.tinymce.get(_this.tinymceId).insertContent("<img class=\"wscnph\" src=\"".concat(v.url, "\" >"));
      });
    }
  }]);
}(_vuePropertyDecorator.Vue);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: function _default() {
    return "vue-tinymce-" + +new Date() + ((Math.random() * 1000).toFixed(0) + "");
  }
})], Tinymce.prototype, "id", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  default: ""
})], Tinymce.prototype, "value", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: Array,
  required: false,
  default: function _default() {
    return [];
  }
})], Tinymce.prototype, "toolbar", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: String,
  default: "file edit insert view format table"
})], Tinymce.prototype, "menubar", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: [Number, String],
  required: false,
  default: 360
})], Tinymce.prototype, "height", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Prop)({
  type: [Number, String],
  required: false,
  default: "auto"
})], Tinymce.prototype, "width", void 0);
(0, _tslib.__decorate)([(0, _vuePropertyDecorator.Watch)("value")], Tinymce.prototype, "watchValue", null);
Tinymce = (0, _tslib.__decorate)([(0, _vuePropertyDecorator.Component)({
  components: {
    editorImage: _EditorImage.default
  }
})], Tinymce);
var _default2 = exports.default = Tinymce;